import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=c5802ef8&scoped=true"
import script from "./BannerTable.vue?vue&type=script&lang=js"
export * from "./BannerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5802ef8",
  null
  
)

export default component.exports